export const createWorklog = /* GraphQL */ `
  mutation CreateWorklog($input: CreateWorklogInput!) {
    createWorklog(input: $input) {
      id
      sk
      description
      worklogTimeSpent
      worklogTimeRemaining
      creator {
        firstName
        lastName
        avatarHash
      }
    }
  }
`;

export const updateWorklog = /* GraphQL */ `
  mutation UpdateWorklog($input: UpdateWorklogInput!) {
    updateWorklog(input: $input) {
      id
      sk
      description
      worklogTimeSpent
      worklogTimeRemaining
      creator {
        firstName
        lastName
        avatarHash
      }
    }
  }
`;

export const deleteWorklog = /* GraphQL */ `
  mutation DeleteWorklog($input: DeleteWorklogInput!) {
    deleteWorklog(input: $input) {
      id
      sk
      description
      worklogTimeSpent
      worklogTimeRemaining
    }
  }
`;

export const getWorklogsForResource = /* GraphQL */ `
  query GetResource($id: ID!, $sk: String!) {
    getResource(id: $id, sk: $sk) {
      id
      sk
      name
      worklogs {
        id
        sk
        createdAt
        worklogTimeSpent
        workspaceId
        creator {
          id
          firstName
          lastName
          avatarHash
        }
      }
    }
  }
`;
